import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { cloneDeep } from 'lodash';
import { ByWordPipe } from '../../../shared/filters/by-word/by-word.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { FieldTypeNumberComponent } from '../../../shared/components/field-type-number/field-type-number.component';
import { NgClass, NgStyle } from '@angular/common';
import { AutoFocusModule } from 'primeng/autofocus';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { SpanTooltipComponent } from "../../../shared/components/span-tooltip/span-tooltip.component";
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
    selector: 'formula-setting-modal',
    templateUrl: './formula-setting-modal.component.html',
    standalone: true,
    imports: [AfTranslateDirective, FormsModule, AutoFocusModule, NgClass, FieldTypeNumberComponent, NgStyle, AfTranslatePipe, ByWordPipe, SpanTooltipComponent]
})
export class FormulaSettingModalComponent implements OnInit {
  configurationField:any = this.dialogConfig.data;
  formulaSettingModal:any = {
    formulaItems: [],
    level: 0,
    formula: '',
    searchFields: '',
    numberValueField: {
      label: this.translate.instant('customize-field-formula.fixed-value'),
      fieldTypeId: 'num',
      placeholder: this.translate.instant('common.write-here')
    },
    operators: [
      { id: '+', valueText:'+', icon: 'lf-icon-sum'},
      { id: '-', valueText:'-', icon: 'lf-icon-less'},
      { id: '*', valueText:'x', icon: 'lf-icon-close'},
      { id: '/', valueText:'/', icon: 'lf-icon-division'},
      { id: '(', valueText:'()', icon: 'lf-icon-open-bracket'},
      { id: ')', valueText:')', icon: 'lf-icon-close-bracket'}
    ]
  }
  constructor( private translate: AfTranslateFactory,
    private dialogRef: DynamicDialogRef<FormulaSettingModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private modalService: ModalServiceService) { }

  ngOnInit(): void {
    this.configureFieldContainers();
    if(this.configurationField.formula){
      this.configureFormulaItems();
    }
  }

  configureFieldContainers(){
    this.configurationField.concept.fieldContainers.forEach((container:any)=>{
      container.show = true;
      container.fields.forEach((field:any)=>{
        field.show = this.configurationField.fieldTypeId !== 'agreg' && this.configurationField.fieldTypeId !== 'agrep'? this.checkFieldContainer(field) : false;
      })
      container.subContainers.forEach((subContainer: any) => {
        subContainer.show = true;
        subContainer.fields.forEach((subField:any)=>{
          subField.show = this.checkFieldSubcontainer(subContainer, subField)
        });
      })
    })
    this.formulaSettingModal.fieldContainers = cloneDeep(this.configurationField.concept.fieldContainers);
  }

  checkFieldSubcontainer(subContainer:any, fieldSubcontainer:any){
    let fieldTypeId:string = fieldSubcontainer.fieldTypeId;
    let fieldNumber: boolean = (fieldTypeId === 'num' || fieldTypeId === 'money');
    let configurationFieldTypeId:string = this.configurationField.fieldTypeId;
    let fieldWeight:boolean = configurationFieldTypeId === 'formp' || configurationFieldTypeId === 'score' || configurationFieldTypeId === 'agrep';
    let fieldNoWeight:boolean = configurationFieldTypeId === 'formu' || configurationFieldTypeId === 'agreg';
    let formuNoWeight:boolean = (fieldNumber || fieldTypeId === 'formu' || fieldTypeId === 'agreg' || fieldTypeId === 'formp' || fieldTypeId === 'agrep');
    let formuWeight:boolean = (fieldNumber || fieldTypeId === 'formp' || fieldTypeId === 'agrep' || fieldTypeId === 'score' || fieldTypeId === 'listp' || fieldTypeId === 'boolp' || fieldTypeId === 'formu' || fieldTypeId === 'agreg');
    let isAgregOrAgrep = configurationFieldTypeId === 'agreg' || configurationFieldTypeId === 'agrep';
    return (fieldTypeId === 'partialScore'
        || (formuNoWeight && fieldNoWeight && fieldSubcontainer.fieldId !== this.configurationField.fieldId)
        || (formuWeight && fieldWeight && fieldSubcontainer.fieldId !== this.configurationField.fieldId))
      && (!isAgregOrAgrep || ( isAgregOrAgrep && subContainer.multiple))
      && (!subContainer.multiple || ( isAgregOrAgrep && subContainer.multiple) || (fieldSubcontainer.fieldContainerId === this.configurationField.fieldContainerId));
  }

  checkFieldContainer(field:any){
    let fieldTypeId:string = field.fieldTypeId;
    let fieldNumber: boolean = (fieldTypeId === 'num' || fieldTypeId === 'money');
    let configurationFieldTypeId:string = this.configurationField.fieldTypeId;
    let fieldWeight:boolean = configurationFieldTypeId === 'formp' || configurationFieldTypeId === 'score';
    let fieldNoWeight:boolean = configurationFieldTypeId === 'formu';
      let formuNoWeight:boolean = (fieldNumber || fieldTypeId === 'formu' || fieldTypeId === 'agreg' || fieldTypeId === 'formp' || fieldTypeId === 'agrep');
      let formuWeight:boolean = (fieldNumber || fieldTypeId === 'formp' || fieldTypeId === 'agrep' || fieldTypeId === 'score' || fieldTypeId === 'listp' || fieldTypeId === 'boolp' || fieldTypeId === 'formu' || fieldTypeId === 'agreg');
    return  (fieldTypeId === 'partialScore'
      || (formuNoWeight && fieldNoWeight && field.fieldId !== this.configurationField.fieldId)
      || (formuWeight && fieldWeight && field.fieldId !== this.configurationField.fieldId));
  }

  configureFormulaItems(){
    if(this.configurationField.formulaFieldsDeleted){
      this.formulaSettingModal.errorValueFormula = true;
    }
    this.configurationField.formulaItems.forEach((item: any) => {
      if(item.type === 'operator'){
        let operator: any = this.isOperator(item.id);
        this.addOperator(operator);
      }else{
        let selectedValue: any = {
          text: item.text,
          key: item.fieldId?item.fieldId:item.text,
          isNumber: item.isNumber,
          deleted: item.deleted
        }
        this.addSelectedValue(selectedValue);
      }
    });
  }

  isOperator(item: any){
    return this.formulaSettingModal.operators.filter((operator:any)=>{ return operator.id === item})[0];
  }

  resetSearch(){
      this.formulaSettingModal.searchFields = '';
  }

  resetFormula(){
    this.formulaSettingModal.formulaItems = [];
    this.formulaSettingModal.level = 0;
  }

  deleteLastItem(){
    let that: any = this.formulaSettingModal;
    if(that.formulaItems.length){
      let lastItem: any = that.formulaItems[that.formulaItems?.length-1];
      if(!this.configurationField.formulaFieldsDeleted || (this.configurationField.formulaFieldsDeleted && lastItem.deleted)){
        delete this.configurationField.formulaFieldsDeleted;
        that.errorValueFormula = false;
      }
      that.formulaItems.splice(that.formulaItems.length-1, 1);
      that.formula = that.formula.substr(0,that.formula.lastIndexOf('#'));
      if(lastItem.text===')'){
        that.level++;
      }else if(lastItem.text==='('){
        that.level--;
      }
    }
  }


  addOperator(operator:any){
    if(this.checkValidAddOperator(operator.id)){
      this.configureNewOperator(operator);
      this.formulaSettingModal.formula += this.formulaSettingModal.formula === ''?operator.id : '#'+operator.id;
      if(!this.configurationField.formulaFieldsDeleted){
        this.formulaSettingModal.errorValueFormula = false;
      }
    }else{
      this.formulaSettingModal.errorValueFormula = true;
    }
  }

  configureNewOperator(operator: any){
    let firstChild: any = this.configureChildrenLevel(operator.id);
    let itemAdded: any = {
      text: operator.valueText,
      id: operator.id,
      type: 'operator',
      level: this.formulaSettingModal.level,
      firstChild: firstChild,
      icon:  operator.icon,
    }
    if(operator.id === ')'){
      this.formulaSettingModal.level--;
    }
    this.formulaSettingModal.formulaItems.push(itemAdded);
  }

  checkValidAddOperator(operator:any){
    let lastItem: any = this.formulaSettingModal.formulaItems[this.formulaSettingModal.formulaItems?.length-1];
    if(lastItem && operator !== '(' && operator !== ')'){
      if((lastItem.type === 'number' || lastItem.text === ')')){
        return true;
      }
      return false;
    }else if(operator === '(' && (!lastItem || (lastItem.text !== ')' && this.formulaSettingModal.level < 5 && lastItem?.type !== 'number'))){
      this.formulaSettingModal.level++;
      return true;
    }else if (operator === ')' && (lastItem?.text === ')' || lastItem?.type === 'number')){
      let countOpenBracket:any = (this.formulaSettingModal.formula.match(/\(/g) || []).length;
      let countCloseBracket:any = (this.formulaSettingModal.formula.match(/\)/g) || []).length;
      if(countOpenBracket > countCloseBracket){
        return true;
      }
      return false;
    }
    return false;
  }

  selectFieldToOperation(field: any){
    field.selected = !field.selected;
    if(field.selected){
      if(this.formulaSettingModal.selectedValue){
        this.resetFieldSelected(this.formulaSettingModal.fieldContainers, field);
      }
      this.formulaSettingModal.selectedValue = cloneDeep(field);
      this.formulaSettingModal.numberValueField.noEditable = true;
    }else{
      delete this.formulaSettingModal.selectedValue;
      this.formulaSettingModal.numberValueField.noEditable = false;
    }
  }

  resetFieldSelected(containers: any, fieldSelected: any = {}){
    for(let i = 0; i < containers.length; i++){
      let fieldContainer = containers[i];
      for(let j = 0; j < fieldContainer.fields.length; j++){
        let field = fieldContainer.fields[j];
        if(field.selected && field.fieldId !== fieldSelected?.fieldId){
          field.selected = false;
          break;
        }
      }
      if(fieldContainer.subContainers?.length){
        this.resetFieldSelected(fieldContainer.subContainers, fieldSelected);
      }
    }
  }

  selectValueToOperation(e: any){
    this.formulaSettingModal.valueNumber = e.newValue;
  }

  addOperationValue(){
    let selectedValue: any = {
      text: this.formulaSettingModal.valueNumber?this.formulaSettingModal.valueNumber:this.formulaSettingModal.selectedValue.label,
      key: this.formulaSettingModal.valueNumber?this.formulaSettingModal.valueNumber:this.formulaSettingModal.selectedValue.fieldId,
      isNumber: this.formulaSettingModal.valueNumber?true:false
    }
    this.addSelectedValue(selectedValue);
  }

  addSelectedValue(selectedValue: any){
    if(this.checkValidAddText()){
      let firstChild: any = this.configureChildrenLevel();
      let itemAdded: any = {
        text: selectedValue.text,
        type: 'number',
        level: this.formulaSettingModal.level,
        firstChild: firstChild,
        deleted: selectedValue.deleted
      }
      this.formulaSettingModal.formulaItems.push(itemAdded);
      if(selectedValue.isNumber){
        this.formulaSettingModal.formula += this.formulaSettingModal.formula === ''?selectedValue.key : '#'+selectedValue.key;
      }else{
        this.formulaSettingModal.formula += this.formulaSettingModal.formula === ''?'['+selectedValue.key+']' : '#['+selectedValue.key+']';
      }
      this.resetValues();
      if(!this.configurationField.formulaFieldsDeleted){
        this.formulaSettingModal.errorValueFormula = false;
      }
    }else{
      this.resetValues();
      this.formulaSettingModal.errorValueFormula = true;
    }
  }

  configureChildrenLevel(operator: string = ''){
    let lastItem: any = this.formulaSettingModal.formulaItems[this.formulaSettingModal.formulaItems.length-1];
    return Boolean ((operator !== '(' && operator !== ')') && (lastItem?.text === '(' || lastItem?.text === ')'));
  }

  resetValues(){
    if(this.formulaSettingModal.valueNumber){
      delete this.formulaSettingModal.valueNumber;
    }else{
      this.resetFieldSelected(this.formulaSettingModal.fieldContainers);
      this.formulaSettingModal.numberValueField.noEditable = false;
    }
  }

  checkValidAddText(){
    let lastItem: any = this.formulaSettingModal.formulaItems[this.formulaSettingModal.formulaItems.length-1];
    return Boolean(!this.formulaSettingModal.formulaItems?.length || (lastItem.type === 'operator' || lastItem.type === 'symbol-full') && lastItem.text !== ')');
  }

  handleAccept(){
    if(this.validateFormula()){
      this.dialogRef.close({
          result: 'ok',
          formula: this.formulaSettingModal.formula,
          items: this.formulaSettingModal.formulaItems
      })
    }else{
      if(this.formulaSettingModal.formula){
        this.formulaSettingModal.errorValueFormula = true;
      }
      this.modalService.errorModal({ text: this.translate.instant('customize-field-formula.formula-error') });
    }
  }

  validateFormula(){
    try{
      if(this.formulaSettingModal.formula && !this.configurationField.formulaFieldsDeleted){
        let formulaListItems: any = this.formulaSettingModal.formula.split('#');
        let formula: string = '';
        formulaListItems.forEach((item:any) => {
          let operator: any = this.isOperator(item);
          formula += operator? item : 1;
          // formula += item.length === 1? item : 1;
        });
        return !isNaN(eval(formula));
      }
      return false;
    }catch(Ex){
      return false;
    }
  }

  handleDismiss(){
    this.dialogRef.close({result:'cancel'});
  }
}
